import { Stack, styled, Typography } from '@mui/material';

type ContentProps = { 'data-is-empty': boolean };

export const Content = styled(Stack)<ContentProps>(
  ({ 'data-is-empty': isEmpty }) => ({
    alignItems: 'center',
    borderBottom: 'var(--border-dark)',
    flexDirection: 'row',
    gap: 'var(--spacing-small)',
    justifyContent: isEmpty ? 'flex-start' : 'space-between',
    paddingBlock: 'var(--spacing-tiny)',
    width: '100%',
  }),
);

export const Heading = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.dark,
  fontSize: 'var(--font-sm)',
  fontWeight: 'var(--font-weight-button-label)',
}));

export const IconWrapper = styled(Stack)(() => ({
  alignItems: 'center',
  justifyContent: 'center',
}));

export const Wrapper = styled('section')(() => ({
  backgroundColor: 'var(--color-background-compose)',
  display: 'flex',
  flexDirection: 'row',
  gap: 'var(--spacing-small)',
  padding: 'var(--spacing-medium)',
  width: '100%',
}));
